import i18next from 'i18next';
import { Trans, useTranslation } from 'react-i18next';

import * as Styled from '../Styles.styles';

function TermsOfUse() {
  const { t } = useTranslation();
  const items = t('termsOfUse.items', { returnObjects: true });

  return (
    <div className="page">
      <Styled.PageTitle>{t('termsOfUse.title')}</Styled.PageTitle>
      <Styled.SectionTerms className="section-terms">
        <Styled.About className="about">
          <p>
            <Trans
              i18nKey={t('termsOfUse.date')}
              components={{
                span: <span className="date" />,
              }}
            />
          </p>
          <p>
            <Trans
              i18nKey={t('termsOfUse.textUnderDate')}
              components={{
                br: <br />,
              }}
            />
          </p>
        </Styled.About>

        <Styled.TermsTable>
          <tbody>
            {items.map((section, sectionIndex) => (
              <tr key={sectionIndex}>
                <th>
                  <Styled.SectionTitle component="p">
                    {section.title}
                  </Styled.SectionTitle>
                </th>
                <td>
                  <ul>
                    {section.list.map((item, listIndex) => (
                      <li key={listIndex}>
                        <Trans
                          i18nKey={item?.text || item}
                          components={{
                            a: <a href="/" target="_blank" rel="noreferrer" />,
                            email: (
                              <a
                                href={`mailto:legal@hudd.${i18next.language === 'sv' ? 'se' : i18next.language}`}
                                rel="noreferrer"
                              />
                            ),
                            strong: <strong />,
                            br: <br />,
                          }}
                        />
                        {item.list && (
                          <ol>
                            {item.list.map((item, index) => (
                              <li key={index}>
                                <strong>{item.title}</strong>
                                <br />
                                <Trans
                                  i18nKey={item.text}
                                  components={{
                                    marketplaceLink: (
                                      <a
                                        href={
                                          'https://www.mapbox.com/legal/marketplace-terms'
                                        }
                                        rel="noreferrer"
                                      />
                                    ),
                                    a: (
                                      <a
                                        href={
                                          i18next.language === 'dk'
                                            ? 'https://www.mitid.dk/en-gb/legal/privacy-notice/'
                                            : i18next.language === 'sv'
                                              ? 'https://www.bankid.com/'
                                              : 'https://vipps.no/personvern-og-vilkar/vipps-terms-and-conditions'
                                        }
                                        rel="noreferrer"
                                      />
                                    ),
                                    strong: <strong />,
                                    br: <br />,
                                  }}
                                />
                              </li>
                            ))}
                          </ol>
                        )}
                      </li>
                    ))}
                  </ul>
                </td>
              </tr>
            ))}
          </tbody>
        </Styled.TermsTable>

        <p>{t('termsOfUse.bottomText')}</p>
        <Styled.Link href="/" rel="noreferrer">
          <Styled.LinksIcon variant="shieldKeyhole" size="sm" />
          {t('termsOfUse.link')}
        </Styled.Link>
      </Styled.SectionTerms>
    </div>
  );
}

export default TermsOfUse;
